// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BDerE","field":"styles_field__1PHeN","fieldCol":"styles_fieldCol__1qsrM","diffCol":"styles_diffCol__kLBnl","diff":"styles_diff__1BItE"};